import { render } from "./SMSBalanceModal.vue?vue&type=template&id=04710e08"
import script from "./SMSBalanceModal.vue?vue&type=script&lang=js"
export * from "./SMSBalanceModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__